import { useEffect, useRef } from "react";

export default function SearchInput({
  label,
  value,
  onChange,
  placeholder,
  results = [],
  onSelect,
  onClear,
  renderResult,
  noResultsLabel = "Nicio potrivire",
  showDropdown = false,
  setShowDropdown = () => {},
  inputProps = {},
  className = "",
  inputClassName = "",
  dropdownClassName = "",
  resultClassName = "",
}) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!showDropdown) return undefined;

    const handleOutsideInteraction = (event) => {
      if (!containerRef.current) return;
      if (!containerRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideInteraction);
    document.addEventListener("focusin", handleOutsideInteraction);
    return () => {
      document.removeEventListener("mousedown", handleOutsideInteraction);
      document.removeEventListener("focusin", handleOutsideInteraction);
    };
  }, [showDropdown, setShowDropdown]);

  return (
    <div className={`space-y-2 ${className}`} ref={containerRef}>
      {label ? <label className="text-sm font-medium text-gray-700">{label}</label> : null}
      <div className="relative">
        <span
          className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-gray-400"
          aria-hidden="true"
        >
          🔍
        </span>
        <input
          type="text"
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          onFocus={() => setShowDropdown(true)}
          placeholder={placeholder}
          className={`w-full rounded-full border border-blue-200/60 bg-white/90 px-9 pr-10 py-2.5 text-sm text-gray-700 shadow-sm transition focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-300/70 ${inputClassName}`}
          {...inputProps}
        />
        {value && (
          <button
            type="button"
            className="absolute right-2 top-1/2 -translate-y-1/2 flex h-7 w-7 items-center justify-center rounded-full bg-blue-100 text-xs font-semibold text-blue-700 shadow hover:bg-blue-200 focus:outline-none focus:ring-2 focus:ring-blue-300"
            onClick={() => {
              onClear?.();
              setShowDropdown(false);
            }}
          >
            ✕
            <span className="sr-only">Șterge</span>
          </button>
        )}
      </div>
      {showDropdown && (
        <div
          className={`mt-1 max-h-56 overflow-y-auto rounded-2xl border border-blue-100/70 bg-white shadow-lg ring-1 ring-blue-100/50 ${dropdownClassName}`}
        >
          {results.length === 0 ? (
            <p className="px-4 py-3 text-sm text-gray-500">{noResultsLabel}</p>
          ) : (
            results.map((item) => (
              <button
                key={item.id || item.value || JSON.stringify(item)}
                type="button"
                className={`w-full px-4 py-3 text-left text-sm transition first:rounded-t-2xl last:rounded-b-2xl hover:bg-blue-50 ${resultClassName}`}
                onClick={() => {
                  onSelect?.(item);
                  setShowDropdown(false);
                }}
              >
                {renderResult ? renderResult(item) : <span>{item.label || item.name}</span>}
              </button>
            ))
          )}
        </div>
      )}
    </div>
  );
}
